import React, { Component } from "react";
import Axios from "axios";
//remember, have to replace data-feather with font awesome icons
import $ from "jquery";
// require("datatables.net-buttons")();
// require("datatables.net-buttons/js/buttons.colVis.js")();

export class UnsubscribeEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.match.params.recipients ? decodeURI(this.props.match.params.recipients) : "",
    };
  }
  componentDidMount() {
    setTimeout(() => {
      $(".splash").removeClass("active");
    }, 500);
  }

  UnsubscribeEmails = () => {
    Axios.post(window.location.protocol + "//" + window.location.hostname + (window.location.port === "3000" ? ":3001" : "") + "/api/email-unsubscribe", { emails: this.state.email.split(",") })
      .then((response) => {
        if (response["data"]["status"] === "Error") {
          this.props.MakeNotification("error", response["data"]["message"] || "There was a backend error. Please try again later.");
        }
        if (response["data"]["status"] === "success") {
          this.props.MakeNotification("success", response.data.message || "You have been unsubscribed.");
          this.setState({ email: "" });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .then(() => {
        // always executed
      });
  };
  render() {
    return (
      <div className="container">
        <div className="splash active">
          <div className="splash-icon"></div>
        </div>
        <div className="header-placeholder" style={{ height: "80px" }}></div>
        <div className="row" id="portal-invoice" style={{ position: "relative" }}>
          <div className="col-md-6 offset-md-3">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">Confirm Unsubscribe</h5>
              </div>
              <div className="card-body">
                <p className="card-text">Please verify your email below to unsubscribe your email from any future emails.</p>
                <p class="card-subtitle text-muted">You can unsubscribe multiple emails by separating them with commas.</p>
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <input
                      className="form-control"
                      value={this.state.email}
                      onChange={(e) => {
                        this.setState({ email: e.target.value });
                      }}
                    />
                  </div>
                  <div className="col-md-6 offset-md-6 mb-2 ">
                    <div className="btn btn-primary float-end" onClick={this.UnsubscribeEmails}>
                      Unsubscribe
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UnsubscribeEmail;
